
import { Component, Vue } from "vue-property-decorator";
import { Company } from "@authentic-labs/vue-component-library";

@Component
export default class AnnualReport extends Vue {
  get company(): Company {
    return this.$store.getters.company;
  }

  companyreport = {
    reporturl: "",
    reportdisplaytext: "",
  };

  industries: Array<string> = [];
  private updateReportURL = false;

  public addAnnualReportUrl() {
    this.onSubmit();
  }

  public deleteAnnualReportUrl() {
    this.company.annualReportUrl = "";
    this.company.annualReportDisplayText = "";
    this.onSubmit();
  }

  public async onSubmit() {
    this.updateReportURL = false;
    try {
      this.$store.dispatch("updateCompany", {
        companyId: this.company.companyId,
        company: this.company,
      });
      this.$root.$emit("alertSuccess", "Company update saved.");
    } catch (error) {
      console.error("Error: ", error);
      this.$root.$emit(
        "alertError",
        "A problem occurred when updating the Company."
      );
    }
  }
}
